
import React from 'react';
import { Activity, User, DollarSign, TrendingUp, Percent } from 'lucide-react';
import { FinanceiroResumo } from '@/types/financeiro';

interface ResumoProps {
  resumo: FinanceiroResumo;
}

const ResumoCards: React.FC<ResumoProps> = ({ resumo }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mb-6">
      <div className="financeiro-card p-5">
        <div className="flex items-start">
          <div className="w-10 h-10 rounded-full bg-financeiro-bg-light flex items-center justify-center text-financeiro-accent mr-3">
            <User className="h-5 w-5" />
          </div>
          <div>
            <div className="text-sm font-medium text-financeiro-text-light">Total de Clientes</div>
            <div className="text-2xl font-semibold text-financeiro-text-dark">{resumo.totalClientes}</div>
          </div>
        </div>
      </div>
      
      <div className="financeiro-card p-5">
        <div className="flex items-start">
          <div className="w-10 h-10 rounded-full bg-financeiro-bg-light flex items-center justify-center text-financeiro-accent mr-3">
            <Activity className="h-5 w-5" />
          </div>
          <div>
            <div className="text-sm font-medium text-financeiro-text-light">Consumo Total</div>
            <div className="text-2xl font-semibold text-financeiro-text-dark">{resumo.totalConsumo.toFixed(0)} kWh</div>
          </div>
        </div>
      </div>
      
      <div className="financeiro-card p-5">
        <div className="flex items-start">
          <div className="w-10 h-10 rounded-full bg-financeiro-bg-light flex items-center justify-center text-financeiro-accent mr-3">
            <DollarSign className="h-5 w-5" />
          </div>
          <div>
            <div className="text-sm font-medium text-financeiro-text-light">Economia Total</div>
            <div className="text-2xl font-semibold text-financeiro-text-dark">R$ {resumo.totalEconomia.toFixed(2)}</div>
          </div>
        </div>
      </div>
      
      <div className="financeiro-card p-5">
        <div className="flex items-start">
          <div className="w-10 h-10 rounded-full bg-financeiro-bg-light flex items-center justify-center text-financeiro-accent mr-3">
            <Percent className="h-5 w-5" />
          </div>
          <div>
            <div className="text-sm font-medium text-financeiro-text-light">Capacidade Utilizada</div>
            <div className="text-2xl font-semibold text-financeiro-text-dark">{resumo.percentualUsoGerador.toFixed(1)}%</div>
          </div>
        </div>
      </div>
      
      <div className="financeiro-card p-5">
        <div className="flex items-start">
          <div className="w-10 h-10 rounded-full bg-financeiro-bg-light flex items-center justify-center text-financeiro-accent mr-3">
            <TrendingUp className="h-5 w-5" />
          </div>
          <div>
            <div className="text-sm font-medium text-financeiro-text-light">Faturamento</div>
            <div className="text-2xl font-semibold text-financeiro-text-dark">R$ {resumo.receitaTotal.toFixed(2)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumoCards;
